import React from 'react'
import Pill from './Pill'

const colorLookups = {
  green: {
    text: 'text-green-800',
    bg: 'bg-green-100',
    ring: 'ring-green-500',
  },
  yellow: {
    text: 'text-yellow-800',
    bg: 'bg-yellow-100',
    ring: 'ring-yellow-500',
  },
  orange: {
    text: 'text-orange-800',
    bg: 'bg-orange-100',
    ring: 'ring-orange-500',
  },
}

interface StatusPillProps {
  color: keyof typeof colorLookups
  children?: React.ReactNode
}

const StatusPill: React.FC<StatusPillProps> = ({ color, children }) => {
  const { text, bg, ring } = colorLookups[color]
  return (
    <Pill color={bg} textColor={text} ringColor={ring}>
      {children}
    </Pill>
  )
}

export default StatusPill
